var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGifts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd578;}.cls-1,.cls-2,.cls-3{stroke:#54596e;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{fill:#ff2000;}.cls-3{fill:#4D902E;}.cls-4{fill:none;stroke:#4D902E;}")), /*#__PURE__*/React.createElement("title", null, "gift"), /*#__PURE__*/React.createElement("g", {
    id: "gift"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,29H55a0,0,0,0,1,0,0V57.54A3.46,3.46,0,0,1,51.54,61H14.46A3.46,3.46,0,0,1,11,57.54V29A0,0,0,0,1,11,29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29,
    y: 29,
    width: 8,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.49,20h39A6.49,6.49,0,0,1,59,26.49V29a0,0,0,0,1,0,0H7a0,0,0,0,1,0,0V26.49A6.49,6.49,0,0,1,13.49,20Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27,
    y: 20,
    width: 12,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,12h0a3,3,0,0,1,3,3v5a0,0,0,0,1,0,0H30a0,0,0,0,1,0,0V15A3,3,0,0,1,33,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,16h7a4,4,0,0,1,4,4v0a0,0,0,0,1,0,0H36a0,0,0,0,1,0,0V16a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.02 16 40.02 12 36.02 16 44.02 16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,16H30a0,0,0,0,1,0,0v0a4,4,0,0,1-4,4H19a0,0,0,0,1,0,0V16A0,0,0,0,1,19,16Z",
    transform: "translate(49 36) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.98 16 25.98 12 29.98 16 21.98 16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 13,
    y1: 8,
    x2: 16,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 16,
    y1: 8,
    x2: 13,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 52,
    y1: 12,
    x2: 55,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55,
    y1: 12,
    x2: 52,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33,
    y1: 2,
    x2: 36,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36,
    y1: 2,
    x2: 33,
    y2: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifts);
export default __webpack_public_path__ + "static/media/gifts.affc0a6884f935ea0e3ce4531db6f064.svg";
export { ForwardRef as ReactComponent };